<template>
    <div id="foot-page" class="websit-foot">
      <div class="foot-body">
        <el-col :span="24"  class="foot-menu" v-if="!$root.is_mobile">
            <span v-for="(nav_item, index) in foot_nav_list" :key="index" 
                class="menu-item" 
                v-bind:class="{'active-nav': currentMenuIndex==nav_item.id,'hover-nav': hoverNavIndex==nav_item.id}"
                v-on:mouseover="hoverNavIndex = nav_item.id" 
                v-on:mouseout="hoverNavIndex = -1"
                v-on:click="change_page(nav_item.id)">
              {{nav_item.nav_name}}
            </span>
        </el-col>
        <div class="imgzoCopyright">
          <span> 版权所有 © 2019-{{copyright_year}} 深圳市微影医疗科技有限公司 </span>
          <span><a href="https://beian.miit.gov.cn/" target="_blank"> 粤ICP备2022008840号</a></span>
        </div>
        <div class="address flex" v-if="!$root.is_mobile">
          <span>深圳总部：深圳市南山区学苑大道1001号南山智园C2栋18楼</span>
          <span>南昌研发中心：江西省南昌市高新开发区火炬大街161号嘉德商业广场海上汇703室</span>
        </div>
      </div>
    </div>
</template>
<script>
export default {
  name: "websitFoot",
  data() {
    return {
      copyright_year:2019,      
      foot_nav_list:[
        {id:5,nav_name:'加入我们'},
        {id:6,nav_name:'联系我们'},
        {id:7,nav_name:'下载中心'}
        ],
      hoverNavIndex:-1,         // 菜单选项覆盖
      currentMenuIndex:this.$parent.currentMenuIndex,
    };  
  },
  mounted() {
    let nowDate = new Date();
    this.copyright_year = nowDate.getFullYear(); //获取完整的年份(4位,1970-)
    setTimeout(() => {
      let imgzoIndex = document.getElementById('imgzoIndex');
      let footPage = document.getElementById('foot-page');
      if (footPage != null) {
        imgzoIndex.style.setProperty("--footPage",(footPage.clientHeight)+'px'); // 动态设置 列表高度  // 16px 为padding+margin
      }
    }, 300);
  },
  methods: {
    change_page(index) {
      this.$parent.currentMenuIndex = index;
      this.currentMenuIndex =index;
      this.$router.replace({path:'/index',query: { page: index}});
    }
  },
};
</script>
<style>
.websit-foot {
  position: absolute;
    bottom: 0px;
    width: 100%;
    z-index: 10;
}
.websit-foot .foot-body {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    background: var(--WhiteColor-1);
    color: var(--SecondColor-9);
    font-size: 80%;
    line-height: 130%;
    padding: 4px 0px;
}
.websit-foot .foot-menu {
    margin: auto;
    padding: 4px;
}
.websit-foot .foot-menu .menu-item {
    padding: 0 8px;
}
.websit-foot .foot-menu .active-nav {
  color: var(--PrimaryColor-7);
}
.websit-foot .foot-menu .hover-nav {
  color: var(--PrimaryColor);
  cursor: pointer;
}
.websit-foot .imgzoCopyright {
    width: 100%;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-content: flex-end;
    justify-content: center;
    align-items: center;
    background: #fff;
}
.websit-foot a {
    text-decoration:none;
    color: var(--SecondColor-9);
}

.websit-foot .address {
  display: flex;
    flex-direction: column;
}

</style>